<template>
    <div class="container login-container">
        <b-overlay :show="showoverlay" class="h-100" rounded="sm">
        <div class="d-flex justify-content-center align-items-center flex-column login-page-main-wrapper">
            <div class="row justify-content-center login-form-wrapper">
                <div class="col-md-7 login-right d-flex align-items-center rounded-right" v-if="showRegister">

                    <div class="users-style">
                        <template v-if="hostname != 'secure.accordhrm.com'">
                            <span class="vendor-logo-wrapper">
                                <img alt="Company Logo" :src="$api_url+'/images/landing-page/'+replaceDotWithUnerscore(hostname)+'.png'" class="brac-bank-logo">
                            </span>
                        </template>
                        <p class="text-center mb-0 login-title">Get <span class="light-green-text">Started</span></p>
                        <p class="text-center" style="font-size: 14px; color: rgba(0, 28, 56, 1); margin: 30px 0 0;">Already have an account? <a type="link" variant="primary" style="font-size: 14px; color: rgba(0, 28, 56, 1); font-weight: 600;" :href="this.$api_url">Login here</a></p>
                        <b-form @submit.stop.prevent="onSubmit">

                            <b-form-group id="name-group" label="Full Name" label-for="name">
                                <b-form-input id="name" name="name" placeholder="" v-model="fdata.name" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="email-group" label="Email/Phone Number" label-for="email">
                                <b-form-input id="email" name="email" placeholder="" v-model="fdata.email" v-validate="{ required: true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email/Phone"></b-form-input>
                                <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="password-group" label="Create a Password" label-for="password">
                                <b-form-input id="password" name="password" placeholder="" type="password" v-model="fdata.password" v-validate="{ password_strength: true }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                                <p style="color: #5B5E63; font-weight: 400; font-size: 9px;" class="mb-3 mt-2 text-left">Use 8 or more characters with a mix of letters, numbers &amp; symbols.</p>
                            </b-form-group>

                            <b-form-group id="password_confirmation-group" label="Confirm Password" label-for="password_confirmation" >
                                <b-form-input id="password_confirmation" name="password_confirmation" placeholder="" type="password" autocomplete="off" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                                <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group class="mb-3 captcha-container">
                                <vue-recaptcha
                                    ref="recaptcha"
                                    @verify="onVerify"
                                    @expired="onExpired"
                                    :sitekey="sitekey" :loadRecaptchaScript=true>
                                    </vue-recaptcha>    
                            
                            </b-form-group>    
                            <b-form-group class="mb-3"> 
                                <div class="row justify-content-center">
                                    
                                        <b-form-checkbox id="checkbox-1" class="m-0 terms-checkbox" v-model="accept_status" name="checkbox-1" value="accepted" unchecked-value="not_accepted">
                                            
                                        </b-form-checkbox>
                                    
                                        <abbr title="Terms of Use" @click="$bvModal.show('modal-terms')" class="text-primary">I accept the terms and use</abbr>
                                    
                                </div>                            
                            </b-form-group>
                            
                            <b-form-group>
                                <div class="clearfix"> 
                                    <b-button type="submit" variant="primary" class="login-btn login-form-submit-btn mt-5 emp-login-btn"  style="width: 260px;">Register</b-button>
                                </div>
                            </b-form-group>
                        </b-form>
                    </div>
                </div>
                <div class="col-md-7 login-right d-flex align-items-center rounded-right" v-else>

                    <div class="users-style">
                        <p class="text-center mb-0 login-title">Verification<span class="light-green-text"></span></p>
                        <p class="text-center" style="font-size: 14px; color: rgba(0, 28, 56, 1); margin: 30px 0;">We have sent you a six digit verification code to your registered email/phone number. Please type in the code to verify your email and get started with accordHRM.</p>
                        <b-form-group id="verification_code-group" label="Verification Code" label-for="verification_code">
                            <b-form-input id="verification_code" name="verification_code" placeholder="" v-model="verification_code" v-validate="{ required: true}" :state="validateState('verification_code')" aria-describedby="verification_code-feedback" data-vv-as="Verification Code"></b-form-input>
                            <b-form-invalid-feedback id="verification_code-feedback">{{ veeErrors.first('verification_code') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <p class="text-right pt-3" style="font-size: 12px; color: rgba(0, 28, 56, 1);">Go Back to <a type="link" variant="primary" style="font-size: 12px; color: rgba(0, 28, 56, 1); font-weight: 600;" :href="this.$api_url">Login Page</a></p>
                        <b-form-group>                        
                            <b-button type="submit" variant="primary" class="login-btn login-form-submit-btn mt-5 emp-login-btn" @click="verify()" style="width: 260px;">Verify</b-button>
                        </b-form-group>                    
                    </div>
                </div>
                <div class="col-md-6 login-left d-flex align-items-center position-relative">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-mgt" v-if="step == 0">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-emp" v-else>
                    <div class="login-left-content-wrapper">
                        <div class="accord-link text-right"><a class='atl-hr-link font-semi-bold' href="https://accordhrm.com/" target="_blank">www.accordhrm.com</a></div>
                        <div class="accord-branding-wrapper text-right">
                            <p>Welcome to</p> 
                            <img  :src="$api_url+'/images/landing-page/logo-white.png'" class="bkash-landing-image">
                        </div>
                        <p class="landing-page-intro-text">HR & Payroll solutions to suit your business</p>
                        <div class="row">
                            <div class="col-md-7">
                                <p class="d-block"><a href="tel:+880-1711-314600"><b-icon icon="telephone-fill" class="mr-1"></b-icon><span class="font-light">+880-1711-314600</span></a></p>
                                <p><a href="mailto:info@accordhrm.com"><b-icon icon="envelope-fill" class="mr-1"></b-icon><span class="font-light">info@accordhrm.com</span></a></p>
                            </div>
                            <div class="col-md-5 d-flex align-items-center justify-content-end">
                                <ul class="p-0 m-0 footer-social-icons">
                                    <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm"><img  :src="$api_url+'/images/landing-page/landing-Facebook.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.linkedin.com/company/accordhrm/"><img  :src="$api_url+'/images/landing-page/landing-Linkedin.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.youtube.com/@accordhrm"><b-icon icon="youtube"></b-icon></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                        <!-- This footer is for mobile -->
                <div class="d-md-none footer-width">
                    <div class="footer-mobile-info-main">
                        <p class="footer-mobile-info "><a class="text-dark" href="tel:+880-1711-314600"><b-icon
                                    icon="telephone-fill" class="mr-1"></b-icon><span
                                    class="font-light">+880-1711-314600</span></a>
                        </p>


                        <p class="footer-email-info">
                            <a class="text-dark" href="mailto:info@accordhrm.com">
                                <b-icon icon="envelope-fill" class="mr-1">
                                </b-icon><span class="font-light">info@accordhrm.com</span>
                            </a>
                        </p>
                    </div>
                    <a class='footer-company text-center' href="https://accordhrm.com/"
                        target="_blank">www.accordhrm.com</a>


                    <div class=" footer-social-icon">
                        <ul class="p-0 m-0 footer-social-icons">
                             <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm">
                                <!-- <img
                                        :src="pageUrl + '/public/images/landing-page/landing-Facebook-alt.png'"
                                        class=""> -->
                                        <b-icon
                                        icon="facebook"></b-icon>
                                    </a>
                                </li>
                            <li class="mr-2"><a target="_blank" href="https://www.linkedin.com/company/accordhrm/">
                                <!-- <img
                                        :src="pageUrl + '/public/images/landing-page/landing-Linkedin-alt.png'"
                                        class=""> -->
                                        <b-icon icon="linkedin"></b-icon>
                                    </a>
                                    </li>
                            <li class="mr-2"><a target="_blank"
                                    href="https://www.youtube.com/@atlhr-smarterhr9465">
                                    <b-icon icon="youtube"></b-icon>
                                </a>
                            </li>
                        </ul>

                        <!-- <ul class="p-0 m-0 footer-social-icons">
                        <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm">
                                <img :src="pageUrl + '/public/images/landing-page/landing-Facebook.png'"
                                    class="bkash-landing-image">
                            </a></li>
                        <li class="mr-2"><a target="_blank" href="https://www.linkedin.com/company/accordhrm/">
                                <img :src="pageUrl + '/public/images/landing-page/landing-Linkedin.png'"
                                    class="bkash-landing-image">
                            </a></li>
                        <li class="mr-2"><a target="_blank" href="https://www.youtube.com/@atlhr-smarterhr9465">
                                <b-icon icon="youtube"></b-icon>
                            </a></li>
                    </ul> -->
                    </div>

                </div>

                <!-- End of mobile footer --> 
        </div>
        </b-overlay>


        <b-modal id="modal-terms" scrollable size="xl" hide-footer title="End User Terms of Use">
            <p class="my-4">
                
                Hello and welcome to accordHRM! Thank you for signing up to use the Platform. Our Platform is enabled via our Site and App (our App is currently available for iOS and Android). 
                We offer various modules, features, and other services through the Platform on a Software-as-a-Services basis. These User Terms of Use ('User Terms') apply to your use of the 
                Services. Definitions for capitalized terms are set out in Exhibit A of these User Terms.
            </p>

            <ol >
                <li >
                    <div class="ms-2 me-auto">
                        Who We Are. accordHRM is a private limited company incorporated in Bangladesh under the Companies Act 1994, and provides Services through the Platform, named accordHRM.
                    </div>                        
                </li>
                <li >
                    <div class="ms-2 me-auto">
                        A Binding Agreement. These User Terms are between you and accordHRM, stipulating the terms and conditions under which the Services are to be offered to you. Please read these User Terms carefully because they are a legally binding agreement and govern your access to and use of the Services. The Effective Date of these User Terms is the day you agree to these User Terms. You may only access or use the Services after you agree to these User Terms. If you do not agree to the User Terms, you may not access or use our Services, irrespective of the Subscriber's subscription.
                    </div>                        
                </li>
                <li > 
                    <div class="ms-2 me-auto"> 
                        ACCEPTING THESE USER TERMS. BY CLICKING THE 'I AGREE' BUTTON, COMPLETING THE REGISTRATION PROCESS, DOWNLOADING OUR APP OR ACCESSING OUR SITE, YOU CONFIRM TO US THAT YOU HAVE READ, AND YOU UNDERSTAND AND AGREE TO BE BOUND BY THESE USER TERMS. 
                    </div> 
                </li> 
                <li > 
                    <div class="ms-2 me-auto"> 
                        Upfront Notices. (i) ALL DISPUTES MUST BE RESOLVED AS PER THE ARBITRATION CLAUSE OF THESE USER TERMS AND THE DECISION OF THE ARBITRATOR(S) SHALL BE FINAL AND BINDING ON BOTH THE PARTIES; AND (ii) BY ACCEPTING THESE USER TERMS, YOU ARE AUTHORIZING US TO ACT ON YOUR BEHALF FOR THE LIMITED PURPOSES OF PROVIDING THE SERVICES TO YOU AND IN CONNECTION WITH THIRD-PARTY SERVICES AND USING YOUR SIGNATURE AS DESCRIBED IN THESE USER TERMS. PLEASE NOTE THAT WE MAY CHANGE THESE USER TERMS AND ANY ASA AT ANY TIME AND IN OUR SOLE DISCRETION. WHEN CHANGES ARE MADE, WE WILL MAKE A COPY OF THE UPDATED USER TERMS AVAILABLE WITHIN THE SERVICES. WE WILL ALSO UPDATE THE 'LAST UPDATED' DATE AT THE TOP OF THESE USER TERMS. IF WE MAKE ANY MATERIAL CHANGES, WE MAY ALSO SEND AN EMAIL TO YOU AT THE LAST EMAIL ADDRESS YOU PROVIDED TO US IN YOUR ACCOUNT. ANY CHANGES TO THESE USER TERMS WILL BE EFFECTIVE IMMEDIATELY FOR NEW USERS AND WILL BE EFFECTIVE FOR EXISTING USERS UPON THE EARLIER OF 30 DAYS AFTER WE POST NOTICE OF SUCH CHANGES WITHIN THE SERVICES OR 30 DAYS AFTER WE DISPATCH AN EMAIL WITH NOTICE OF SUCH CHANGES. WE MAY REQUIRE YOU TO PROVIDE CONSENT TO THE UPDATED USER TERMS IN A SPECIFIED MANNER BEFORE FURTHER USE OF THE SERVICES IS PERMITTED. IF YOU DO NOT AGREE TO ANY CHANGE(S) AFTER RECEIVING A NOTICE OF SUCH CHANGE(S), YOU WILL STOP USING THE SERVICES; OTHERWISE, YOUR CONTINUED USE OF THE SERVICES SHALL BE DEEMED TO BE YOUR ACCEPTANCE OF SUCH CHANGE(S). PLEASE REGULARLY CHECK THE SERVICES TO VIEW THE THEN-CURRENT USER TERMS.

                    </div> 
                </li>
                

            </ol>
            <div class="col-md-12 text-center mt-3">
                <b-button class="ml-2" @click="$bvModal.hide('modal-terms')">Close</b-button>
            </div>
        </b-modal>

    </div>    
    
</template> 
<script>
    import VueRecaptcha from 'vue-recaptcha';
    import { Validator } from 'vee-validate';
    export default{
        
        mounted() {
            //console.log('login form info started..');   
            //console.log(this.data);  
        },
        components: {
            'vue-recaptcha': VueRecaptcha,
        },
        data(){            
            
            return {
                                   
                successmsg:'',
                errormsg:[],
                fdata: {email: null , name:null, password:null , password_confirmation:null},

                showoverlay : false,

                showRegister : true,
                verification_code : null,
                captcha_verify : false,

                accept_status : null,

                //sitekey: '6LdOYzsbAAAAAOvXGo3cpT1A_m6dsYEEcLczJMCa',
                sitekey: '6Leg2jMqAAAAAD_UnKTKkLpPof4VETXi8nBo7nU0',

                hostname: window.location.hostname,
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetvalidator()
            {
                 this.$validator.reset();
            },
            validateEmail(email) 
            {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },
            resetForm()
            {
                this.fdata = {
                    
                    //asd:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.captcha_verify = true;

            },
            onExpired: function () {
                //console.log('Expired')
                this.captcha_verify = false;
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            verify()
            {
                let currentObj = this;

                let submitUrl = this.$api_url + '/employee/verify';

                let formData = new FormData();
                
                formData.append('verification_code', this.verification_code);

                axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                    
                                    if(response.data.status == 1)
                                    {
                                        /* currentObj.$bvToast.toast('Successfully Verified!', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true,
                                            toaster: 'b-toaster-top-center',
                                        }); */
                                        
                                        window.location.href = this.$api_url;
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('Wrong verification code', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            toaster: 'b-toaster-top-center',
                                        });

                                        
                                    }
                                    
                                }.bind(this))
                                .catch(function (error){ currentObj.serverError(error); });

            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;

                if(this.captcha_verify == false)
                {
                    this.$bvToast.toast('Sorry but you must fill in the CAPTCHA below to complete the procedure.', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                    return false;
                }
                 

                if(this.accept_status != 'accepted') 
                {
                    this.$bvToast.toast('Please agree with terms and use to proceed.', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                    return false;
                }
                

                let submitUrl = '';

                let auth_by = 1; // if registered by email

                let auth_with = 'phone number';

                if(this.validateEmail(this.fdata.email))
                {            
                    auth_with = 'email address';        
                    submitUrl = this.$api_url + '/employee/register?f=1';
                }
                    
                else if(isNaN(this.fdata.email) === false)
                {
                    auth_by = 2; // if registered by phone
                    submitUrl = this.$api_url + '/employee/register';
                }
                    
                else
                {
                    alert('Wrong Email/Phone number');
                    return false;
                }
                    
                
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true; 

                    e.preventDefault();  
                    let currentObj = this;

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                    //console.log(response.data);                                
                                    //window.location.href = this.$api_url;
                                    if(response.data.status == 1)
                                    {
                                        this.showRegister = false;

                                        let t_msg = "Please check ";

                                        /*if(auth_by == 1)
                                            t_msg = t_msg + "email";
                                        else
                                            t_msg = t_msg + "phone";*/

                                        t_msg = 'A six digit verification code has been sent to the specified ' + auth_with + '. To finish resetting your password, enter the verification code below.';

                                        /* currentObj.$bvToast.toast(t_msg , {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        }); */
                                    }
                                    else if(response.data.status == 2)
                                    {
                                        let t_msg = "You already have an unverified account. Please check ";

                                        if(auth_by == 1)
                                            t_msg = t_msg + "email";
                                        else
                                            t_msg = t_msg + "phone";

                                        t_msg = t_msg + " for verification code.";

                                        currentObj.$bvToast.toast(t_msg , {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });

                                        this.showRegister = false;
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('You already have an account or a user is already logged in.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        }); 
                                        
                                    }

                                    this.showoverlay = false; 
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    this.showoverlay = false; 
                                    //this.errormsg = error;
                                    currentObj.serverError(error);
                                    /*currentObj.$bvToast.toast('These credentials do not match our records.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); */
                                });
                });
            },            

        },
        created: function(){
            //
            Validator.extend('password_strength', {
                params: ['target'],
                validate(value) {
                    const hasUppercase = /[A-Z]/.test(value);
                    const hasLowercase = /[a-z]/.test(value);
                    const hasNumber = /[0-9]/.test(value);
                    const hasSpecial = /[!@#\$%\^\&*\)\(+=._-]/.test(value);
                    const isAlphanumeric = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/.test(value);                   
                    const len = value.length >= 12;
                    const checks = [hasUppercase, hasLowercase, hasNumber, hasSpecial ].filter(Boolean).length;

                    return len && isAlphanumeric && hasSpecial && checks >= 4;
                },
                getMessage(field, args) {                    
                    return "Password must be at least 12 characters longh and meet the following: uppercase, lowercase, numbers and symbols.";
                },                
            });
        }
    }
</script>

<style>
ul.login-tabs-nav.nav-pills {border: none !important;}
ul.login-tabs-nav.nav-pills li a, ul.login-tabs-nav.nav-pills li:last-child a {border: 1px solid #464d5c !important;}
ul.login-tabs-nav.nav-pills li a.active {border: 1px solid #3490dc !important;}
ul.login-tabs-nav.nav-pills li, ul.login-tabs-nav.nav-pills li a {color: #dee6ff;}
.login-tabs-nav .nav-item:last-child a {
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}
.login-tabs-nav .nav-item:first-child a {
	border-top-left-radius: 0.25rem !important;
	border-bottom-left-radius: 0.25rem !important;
}
</style>
